/* ============================================================
   mt-scripts.js — interacciones propias (vanilla, sin librerias)
   Una funcion init por componente; cada una comprueba si su
   elemento existe antes de actuar.
   ============================================================ */
(function () {
  "use strict";

  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Activa el modo animación solo si vamos a poder gestionarlo.
  if (!reduceMotion) {
    document.documentElement.classList.add("mt-anim");
  }

  /* ---- Reveal al hacer scroll (observer compartido) ---- */
  function initReveals() {
    var els = document.querySelectorAll(".mt-reveal");
    if (!els.length) return;

    function show(el) {
      var group = el.closest("[data-mt-stagger]");
      if (group && !group.dataset.mtStaggered) {
        group.dataset.mtStaggered = "1";
        var kids = group.querySelectorAll(".mt-reveal");
        kids.forEach(function (kid, i) {
          kid.style.setProperty("--mt-reveal-delay", Math.min(i, 6) * 85 + "ms");
          kid.classList.add("is-visible");
        });
      } else {
        el.classList.add("is-visible");
      }
    }

    function showAll() {
      els.forEach(function (el) { el.classList.add("is-visible"); });
    }

    if (reduceMotion || !("IntersectionObserver" in window)) {
      showAll();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          show(entry.target);
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -6% 0px" }
    );

    els.forEach(function (el) {
      // lo que ya está en pantalla (o casi) al cargar: mostrar sin esperar
      var top = el.getBoundingClientRect().top;
      if (top < window.innerHeight * 1.05) {
        show(el);
      } else {
        io.observe(el);
      }
    });

    // Red de seguridad: si algo queda sin revelar (pestaña en segundo plano,
    // observer que no dispara...), se muestra igualmente.
    setTimeout(function () {
      var pending = document.querySelectorAll(".mt-reveal:not(.is-visible)");
      pending.forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add("is-visible");
      });
    }, 1200);
    setTimeout(showAll, 4000);
  }

  /* ---- Contadores animados ---- */
  function initCounters() {
    var els = document.querySelectorAll("[data-mt-count]");
    if (!els.length) return;

    function staticFormat(el) {
      var raw = el.dataset.mtCount.replace(",", ".");
      var decimals = (raw.split(".")[1] || "").length;
      var n = parseFloat(raw).toLocaleString("es-ES", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
      el.textContent = (el.dataset.mtCountPrefix || "") + n + (el.dataset.mtCountSuffix || "");
    }

    // valor correcto de entrada; la animación (si el observer dispara) lo sobrescribe
    els.forEach(staticFormat);

    if (reduceMotion || !("IntersectionObserver" in window)) {
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var raw = el.dataset.mtCount.replace(",", ".");
        var target = parseFloat(raw);
        var decimals = (raw.split(".")[1] || "").length;
        var suffix = el.dataset.mtCountSuffix || "";
        var prefix = el.dataset.mtCountPrefix || "";
        var dur = 1500;
        var start = performance.now();
        function fmt(n) {
          return n.toLocaleString("es-ES", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
        }
        function tick(now) {
          var p = Math.min((now - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = prefix + fmt(target * eased) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.5 });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Antes / despues ---- */
  function initBeforeAfter() {
    var widgets = document.querySelectorAll("[data-mt-ba]");
    if (!widgets.length) return;

    widgets.forEach(function (el) {
      var afterImg = el.querySelector(".mt-ba__after");
      var handle = el.querySelector(".mt-ba__handle");
      var dragging = false;

      function setPos(clientX) {
        var rect = el.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(2, Math.min(98, pct));
        el.style.setProperty("--mt-ba-pos", pct + "%");
      }

      function down(e) {
        dragging = true;
        el.classList.add("is-dragging");
        setPos(e.touches ? e.touches[0].clientX : e.clientX);
      }
      function move(e) {
        if (!dragging) return;
        setPos(e.touches ? e.touches[0].clientX : e.clientX);
      }
      function up() {
        dragging = false;
        el.classList.remove("is-dragging");
      }

      el.addEventListener("mousedown", down);
      el.addEventListener("touchstart", down, { passive: true });
      window.addEventListener("mousemove", move);
      window.addEventListener("touchmove", move, { passive: true });
      window.addEventListener("mouseup", up);
      window.addEventListener("touchend", up);

      el.addEventListener("keydown", function (e) {
        var cur = parseFloat(getComputedStyle(el).getPropertyValue("--mt-ba-pos")) || 50;
        if (e.key === "ArrowLeft") { el.style.setProperty("--mt-ba-pos", Math.max(2, cur - 4) + "%"); }
        if (e.key === "ArrowRight") { el.style.setProperty("--mt-ba-pos", Math.min(98, cur + 4) + "%"); }
      });

      // reveal sutil al entrar
      if (!reduceMotion && "IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.unobserve(el);
            var t = 30;
            var dir = 1;
            var iv = setInterval(function () {
              t += dir * 2;
              el.style.setProperty("--mt-ba-pos", t + "%");
              if (t >= 62) dir = -1;
              if (t <= 50 && dir === -1) { clearInterval(iv); el.style.setProperty("--mt-ba-pos", "50%"); }
            }, 16);
          });
        }, { threshold: 0.4 });
        io.observe(el);
      }
    });
  }

  /* ---- Acordeon (FAQ) ---- */
  function initAccordions() {
    var items = document.querySelectorAll(".mt-acc__item");
    if (!items.length) return;

    items.forEach(function (item) {
      var trigger = item.querySelector(".mt-acc__trigger");
      var panel = item.querySelector(".mt-acc__panel");
      if (!trigger || !panel) return;

      trigger.addEventListener("click", function () {
        var isOpen = item.classList.contains("is-open");
        var group = item.closest("[data-mt-acc-single]");
        if (group && !isOpen) {
          group.querySelectorAll(".mt-acc__item.is-open").forEach(function (other) {
            other.classList.remove("is-open");
            other.querySelector(".mt-acc__panel").style.height = "0px";
            other.querySelector(".mt-acc__trigger").setAttribute("aria-expanded", "false");
          });
        }
        if (isOpen) {
          panel.style.height = panel.scrollHeight + "px";
          requestAnimationFrame(function () { panel.style.height = "0px"; });
          item.classList.remove("is-open");
          trigger.setAttribute("aria-expanded", "false");
        } else {
          item.classList.add("is-open");
          trigger.setAttribute("aria-expanded", "true");
          panel.style.height = panel.scrollHeight + "px";
          panel.addEventListener("transitionend", function te() {
            if (item.classList.contains("is-open")) panel.style.height = "auto";
            panel.removeEventListener("transitionend", te);
          });
        }
      });
    });
  }

  /* ---- Escena "como funciona": pasos activos con scroll ---- */
  function initStickyScene() {
    var scenes = document.querySelectorAll("[data-mt-scene]");
    if (!scenes.length) return;

    scenes.forEach(function (scene) {
      var steps = scene.querySelectorAll("[data-mt-scene-step]");
      var visuals = scene.querySelectorAll("[data-mt-scene-visual]");
      if (!steps.length) return;

      if (!("IntersectionObserver" in window)) {
        steps[0].classList.add("is-active");
        if (visuals[0]) visuals[0].classList.add("is-active");
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var idx = entry.target.getAttribute("data-mt-scene-step");
          steps.forEach(function (s) { s.classList.toggle("is-active", s.getAttribute("data-mt-scene-step") === idx); });
          visuals.forEach(function (v) { v.classList.toggle("is-active", v.getAttribute("data-mt-scene-visual") === idx); });
        });
      }, { threshold: 0.6, rootMargin: "-20% 0px -30% 0px" });

      steps.forEach(function (s) { io.observe(s); });
    });
  }

  /* ---- Tabs (modos) ---- */
  function initTabs() {
    var groups = document.querySelectorAll("[data-mt-tabs]");
    if (!groups.length) return;

    groups.forEach(function (group) {
      var tabs = group.querySelectorAll("[data-mt-tab]");
      var panels = group.querySelectorAll("[data-mt-tab-panel]");
      tabs.forEach(function (tab) {
        tab.addEventListener("click", function () {
          var id = tab.getAttribute("data-mt-tab");
          tabs.forEach(function (t) { t.classList.toggle("is-active", t === tab); t.setAttribute("aria-selected", t === tab ? "true" : "false"); });
          panels.forEach(function (p) { p.classList.toggle("is-active", p.getAttribute("data-mt-tab-panel") === id); });
        });
      });
    });
  }

  /* ---- Carrusel de resenas (arrastrar + botones) ---- */
  function initCarousel() {
    var carousels = document.querySelectorAll("[data-mt-carousel]");
    if (!carousels.length) return;

    carousels.forEach(function (root) {
      var track = root.querySelector("[data-mt-carousel-track]");
      var prev = root.querySelector("[data-mt-carousel-prev]");
      var next = root.querySelector("[data-mt-carousel-next]");
      if (!track) return;

      function step() {
        var card = track.querySelector(".mt-card");
        if (!card) return track.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 24;
        return card.getBoundingClientRect().width + gap;
      }
      if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
      if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });

      var isDown = false, startX, scrollLeft;
      track.addEventListener("mousedown", function (e) {
        isDown = true; track.classList.add("is-grabbing");
        startX = e.pageX - track.offsetLeft; scrollLeft = track.scrollLeft;
      });
      track.addEventListener("mouseleave", function () { isDown = false; track.classList.remove("is-grabbing"); });
      track.addEventListener("mouseup", function () { isDown = false; track.classList.remove("is-grabbing"); });
      track.addEventListener("mousemove", function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - track.offsetLeft;
        track.scrollLeft = scrollLeft - (x - startX) * 1.4;
      });
    });
  }

  /* ---- Gallery de la pagina de producto ---- */
  function initProductGallery() {
    var gal = document.querySelector("[data-mt-gallery]");
    if (!gal) return;
    var main = gal.querySelector("[data-mt-gallery-main] img");
    var thumbs = gal.querySelectorAll("[data-mt-gallery-thumb]");
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var full = thumb.getAttribute("data-full");
        if (!full) return;
        main.style.opacity = "0";
        setTimeout(function () {
          main.src = full;
          main.srcset = "";
          main.style.opacity = "1";
        }, 180);
        thumbs.forEach(function (t) { t.classList.toggle("is-active", t === thumb); });
      });
    });
  }

  /* ---- Selector de variantes (pagina de producto) ---- */
  function initVariantPicker() {
    var form = document.querySelector("form.mt-pdp__form, #mt-pdp-form, [data-mt-product-form]");
    if (!form) return;
    var dataEl = document.querySelector("[data-mt-variant-data]");
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector("[data-mt-price]");
    var compareEl = document.querySelector("[data-mt-compare]");
    var submitBtn = form.querySelector('[type="submit"]');
    var submitLabel = submitBtn ? submitBtn.querySelector("[data-mt-btn-label]") : null;
    var optionInputs = form.querySelectorAll("[data-mt-option]");
    var moneyFormat = dataEl.getAttribute("data-money-format") || "{{amount}} €";

    function formatMoney(cents) {
      var noDecimals = /no_decimals/.test(moneyFormat);
      var amount = (cents / 100).toLocaleString("es-ES", {
        minimumFractionDigits: noDecimals ? 0 : 2,
        maximumFractionDigits: noDecimals ? 0 : 2,
      });
      if (/\{\{\s*amount[^}]*\}\}/.test(moneyFormat)) {
        return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]+>/g, "").trim();
      }
      return amount + " €";
    }

    function currentOptions() {
      var opts = [];
      optionInputs.forEach(function (group) {
        var checked = group.querySelector("input:checked") || group.querySelector("select");
        if (checked) opts.push(checked.value);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function update() {
      var v = findVariant(currentOptions());
      if (!v) {
        if (submitBtn) { submitBtn.disabled = true; }
        if (submitLabel) submitLabel.textContent = "No disponible";
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (submitBtn) submitBtn.disabled = !v.available;
      if (submitLabel) submitLabel.textContent = v.available ? (submitBtn.getAttribute("data-label-default") || "Añadir a la cesta") : "Agotado";

      // swatch activo + etiqueta de opción
      optionInputs.forEach(function (group) {
        var current = group.querySelector("[data-mt-option-current]");
        group.querySelectorAll("[data-mt-swatch]").forEach(function (lbl) {
          var input = lbl.querySelector("input");
          var on = input && input.checked;
          lbl.classList.toggle("is-active", on);
          if (on && current) current.textContent = input.value;
        });
      });
    }

    optionInputs.forEach(function (group) {
      group.addEventListener("change", update);
    });
    update();
  }

  /* ---- Añadir a la cesta sin salir de la página (abre el cajón) ---- */
  function initAddToCart() {
    var form = document.querySelector("form.mt-pdp__form, #mt-pdp-form");
    if (!form) return;
    var drawer = document.querySelector("cart-drawer");
    if (!drawer) return; // sin cajón: comportamiento normal (va a /cart)

    var btn = form.querySelector('[type="submit"]');

    form.addEventListener("submit", function (e) {
      if (form.dataset.mtBusy) return;
      e.preventDefault();
      form.dataset.mtBusy = "1";
      var label = btn ? btn.querySelector("[data-mt-btn-label]") : null;
      var prev = label ? label.textContent : "";
      if (label) label.textContent = "Añadiendo…";
      if (btn) btn.disabled = true;

      var body = new FormData(form);
      var sectionsToGet = ["cart-drawer", "cart-icon-bubble"];
      body.append("sections", sectionsToGet.join(","));
      body.append("sections_url", window.location.pathname);

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : "/cart/add") + ".js", {
        method: "POST",
        headers: { Accept: "application/javascript" },
        body: body,
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { throw new Error(res.description || "add error"); }
          if (res.sections) {
            Object.keys(res.sections).forEach(function (key) {
              var markup = res.sections[key];
              if (key === "cart-drawer") {
                var tmp = document.createElement("div");
                tmp.innerHTML = markup;
                var fresh = tmp.querySelector("#CartDrawer") || tmp.querySelector(".drawer__inner");
                var target = document.querySelector("#CartDrawer") || drawer.querySelector(".drawer__inner");
                if (fresh && target) target.innerHTML = fresh.innerHTML;
                drawer.classList.remove("is-empty");
              }
              if (key === "cart-icon-bubble") {
                var bubble = document.getElementById("cart-icon-bubble");
                if (bubble) bubble.innerHTML = new DOMParser().parseFromString(markup, "text/html").querySelector(".shopify-section").innerHTML;
              }
            });
          }
          if (typeof drawer.open === "function") drawer.open(btn);
          else drawer.classList.add("active"), document.body.classList.add("overflow-hidden");
        })
        .catch(function () {
          form.submit(); // plan B: recarga a /cart
        })
        .finally(function () {
          form.dataset.mtBusy = "";
          if (btn) btn.disabled = false;
          if (label) label.textContent = prev || (btn && btn.getAttribute("data-label-default")) || "Añadir a la cesta";
        });
    });
  }

  /* ---- Init ---- */
  document.addEventListener("DOMContentLoaded", function () {
    initReveals();
    initCounters();
    initBeforeAfter();
    initAccordions();
    initStickyScene();
    initTabs();
    initCarousel();
    initProductGallery();
    initVariantPicker();
    initAddToCart();
  });
})();
